import { Input } from 'antd';
import { OTPProps } from 'antd/es/input/OTP';

export const InputOTP = (props: OTPProps) => {
  return <Input.OTP {...props} />;
};
